import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { List } from 'antd'

import { Request, RequestTicket } from 'src/types'
import { Switch, Tooltip } from 'src/components/Ant'

import TicketItem from './ticket-item'
import { useUpdatesPendingIssueTickets } from '../util'
import { WrapOptionCancel } from '../../styles'

type Props = {
  canEdit: boolean
  request: Request
}

function Airs({ canEdit, request }: Props) {
  const { t } = useTranslation()
  const { isTicketsPending, handleChange } =
    useUpdatesPendingIssueTickets('AIR')
  const selectedAirs = useMemo<RequestTicket[]>(
    () =>
      request.request_tickets.filter(
        requestTicketItem =>
          requestTicketItem.class_type === 'SERVICE' &&
          requestTicketItem.request_ticket_type === 'AIR'
        // && requestTicketItem.status === 'EMISSION_PENDING'
      ),
    [request.request_tickets]
  )

  const canSendRequest = selectedAirs.some(
    ({ status }) => status === 'EMISSION_PENDING'
  )

  return (
    <>
      {canSendRequest && (
        <Tooltip title="web.agencies.cancel-tickets.cancel-hint">
          <WrapOptionCancel>
            <Switch
              style={{ width: '200px' }}
              disabled={false}
              unCheckedChildren={t(
                'web.agencies.cancel-tickets.cancel-unchecked'
              )}
              checkedChildren={t('web.agencies.cancel-tickets.cancel-checked')}
              checked={isTicketsPending}
              onChange={handleChange}
            />
          </WrapOptionCancel>
        </Tooltip>
      )}
      <List
        dataSource={selectedAirs}
        grid={{ gutter: 24, column: 2 }}
        itemLayout="vertical"
        renderItem={item => (
          <TicketItem
            canEdit={canEdit}
            key={item.request_ticket_id}
            item={item}
          />
        )}
        style={{ margin: '0 24px' }}
      />
    </>
  )
}

export default Airs
